import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { LoanAccountsDetailHoldingsRoute } from './LoanAccountsDetailHoldingsRoute';
import { LoanAccountsDetailsOverviewRouter } from './LoanAccountsDetailOverviewRoute';
import { LoanAccountsOverviewRouter } from './LoanAccountsOverviewRoute';
import { LoanAccountsOverviewUnderMarginReportRouter } from './LoanAccountsOverviewUnderMarginReportRoute';
import { ValleyBankTemplate } from 'valleyBank/domains/page/ui/ValleyBankTemplate';

export const LoanAccountsRouter = withLDConsumer()(() => {
  return (
    <ValleyBankTemplate canToggleDataSource>
      <Switch>
        <Route
          exact
          path="/loan-accounts"
          component={LoanAccountsOverviewRouter}
        />
        <Route
          exact
          path="/loan-accounts/under-margin-report"
          component={LoanAccountsOverviewUnderMarginReportRouter}
        />
        <Route
          exact
          path="/loan-accounts/summary"
          component={LoanAccountsDetailsOverviewRouter}
        />
        <Route
          exact
          path="/loan-accounts/holdings"
          component={LoanAccountsDetailHoldingsRoute}
        />
      </Switch>
    </ValleyBankTemplate>
  );
});
